export default __webpack_public_path__ + "static/media/740.1efef436.png";